import { SaveOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Spin
} from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import EmpresaContext from '../../context/empresa-context';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 }
  }
};

const SucursalForm = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const { empresa } = useContext(EmpresaContext);
  const [model, setModel] = useState();
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [datosCambiados, setDatosCambiados] = useState({});
  const [datosCambiados2, setDatosCambiados2] = useState({});

  const onFinish = async (values) => {
    try {
      if (id) {
        setDatosCambiados2({
          id,
          ...values,
          id_empresa: empresa.id
        });
        showModal();
      } else {
        setLoading(true);
        await instanceRef.instance.post(`sucursal`, {
          ...values,
          id_empresa: empresa.id
        });
        message.success('Sucursal creada correctamente');
        history.push('/sucursales');
      }
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  const update = async () => {
    try {
      if (!(Object.entries(datosCambiados2).length === 0)) {
        setLoading(true);
        await instanceRef.instance.put(`sucursal/${id}`, datosCambiados2);
        message.success('Sucursal actualizada correctamente');
        history.push('/sucursales');
      }
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  useEffect(() => {
    const loadModel = async () => {
      try {
        const response = await instanceRef.instance.get(`/sucursal/${id}`);
        if (response.data?.data) {
          setModel({
            ...response.data?.data
          });
          setDatosCambiados2({ ...response.data?.data });
        }
      } catch (error2) {
        errorHandler(error2);
      }
      setLoading(false);
    };
    if (id && form) {
      loadModel();
    }
  }, [id, form]);

  useEffect(() => {
    form.resetFields();
  }, [model, form]);

  const verificarCodigo = async (_, value) => {
    try {
      const empresaId = empresa.id;
      const response = await instanceRef.instance.post('/sucursal/codigo', {
        params: { codigo: value, empresaId }
      });
      if (response.data.data) {
        if (!id || (id && response.data.data.id !== parseInt(id, 10))) {
          return Promise.reject(
            new Error(`Sucursal con el mismo código ya existe`)
          );
        }
      }
    } catch (err) {
      // error
    }
    return Promise.resolve();
  };

  const verificarNombre = async (_, value) => {
    try {
      const empresaId = empresa.id;
      const response = await instanceRef.instance.post('/sucursal/nombre', {
        params: { nombre: value, empresaId }
      });
      if (response.data.data?.length > 0) {
        if (!id || (id && response.data.data[0].id !== parseInt(id, 10))) {
          return Promise.reject(
            new Error(`Sucursal con el mismo nombre ya existe`)
          );
        }
      }
    } catch (err) {
      // error
    }
    return Promise.resolve();
  };

  const handleInputChange = async (field, value) => {
    try {
      setDatosCambiados({ ...datosCambiados, [field]: value.target.value });
    } catch (error2) {
      // error
    }
  };
  const handleInputChange2 = async (field, value) => {
    try {
      setDatosCambiados2({ ...datosCambiados2, [field]: value.target.value });
    } catch (error2) {
      // error
    }
  };

  const showModal = () => {
    if (!(Object.entries(datosCambiados).length === 0)) {
      setVisible(true);
    } else {
      message.warning('No hay datos modificados');
    }
  };

  const handleOk = () => {
    setVisible(false);
    update();
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <ResponsiveContainer size="large">
      <Card
        title={`${!id ? 'Agregar' : 'Editar'} Sucursal`}
        style={{ textAlign: 'left' }}
      >
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <div style={{ maxWidth: '500px' }}>
            <Form
              {...formItemLayout}
              initialValues={model}
              scrollToFirstError
              form={form}
              name="sucursal"
              autoComplete="off"
              layout="vertical"
              onFinish={onFinish}
            >
              <Form.Item
                label="Código"
                rules={[
                  {
                    required: true,
                    whitespace: true
                  },
                  {
                    validator: verificarCodigo
                  }
                ]}
                name="codigo"
                normalize={(value) => {
                  if (value) {
                    return value.replace(/\s+/g, '');
                  }
                  return value;
                }}
                onChange={(e) => {
                  handleInputChange('Código', e);
                  handleInputChange2('codigo', e);
                }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Nombre"
                rules={[
                  {
                    required: true,
                    whitespace: true
                  },
                  {
                    validator: verificarNombre
                  }
                ]}
                name="descripcion"
                onChange={(e) => {
                  handleInputChange('Nombre', e);
                  handleInputChange2('descripcion', e);
                }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Dirección"
                rules={[
                  {
                    required: true,
                    whitespace: true
                  }
                ]}
                name="direccion"
                onChange={(e) => {
                  handleInputChange('Dirección', e);
                  handleInputChange2('direccion', e);
                }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Teléfono"
                rules={[
                  { required: true },
                  {
                    pattern: `^[0-9/ \\+\\-\\(\\)]*$`,
                    message: 'Número no válido'
                  }
                ]}
                name="telefono"
                onChange={(e) => {
                  handleInputChange('Teléfono', e);
                  handleInputChange2('telefono', e);
                }}
              >
                <Input />
              </Form.Item>

              <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                {!id ? 'Guardar' : 'Actualizar'}
              </Button>
            </Form>
          </div>
        </Spin>
      </Card>
      <Modal
        title="Los datos fueron editados. ¿Está seguro de querer guardarlos?"
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <>
          {Object.keys(datosCambiados).map((key) => (
            <Row key={key}>
              <Col span={8} align="start">
                <p>{`${key}`}</p>
              </Col>
              <Col span={8} align="start">
                <strong>{`${datosCambiados[key]}`}</strong>
              </Col>
            </Row>
          ))}
        </>
      </Modal>
    </ResponsiveContainer>
  );
};

export default SucursalForm;
